// ==========================  TABLE ENUM ==========================
export enum Tables {
  AdminUsers = 'admin_users',
  Banners = 'banners',
  Clients = 'clients',
  Banner_Categories = 'banner_categories',
  Jobs = 'jobs',
  Jobs_Role_List = 'jobs_role_list',
  Job_Types = 'job_types',
  Job_Applicants = 'job_applicants',
  DentalProfessionals = 'dental_professionals',
  DentalPractices = 'dental_practices',
  DentalSuppliers = 'dental_suppliers',
  Courses = 'courses',
  Catalogues = 'catalogues',
  Newsfeeds = 'newsfeeds',
  Directories = 'directories',
  NewsfeedCategories = 'newsfeed_categories',
  CatalogueSubCategories = 'catalogue_sub_categories',
  Course_type = 'course_type',
  Course_catagories = 'course_categories',
  Registered_User_Claim = 'registered_user_claim',
  Course_Registered_Users = 'course_registered_users',
  Community_Members = 'community_members',
  Partnership_Members = 'partnership_members',
  Newsfeed_Comments = 'news_feeds_comments',
  Comments_Replys = 'news_feeds_comments_replys',
  Newsfeeds_Likes = 'newsfeeds_likes',
}
// ==========================  COURSE FIELDS ==========================
const COURSE_FIELDS = [
  'id',
  'created_at',
  'updated_at',
  'course_name',
  'course_category_id',
  'contact_name',
  'type',
  'startDate',
  'endDate',
  'startTime',
  'endTime',
  'presenters',
  'description',
  'address',
  'cpd_points',
  'number_of_seats',
  'early_bird_end_date',
  'early_bird_price',
  'afterwards_price',
  'topics_included',
  'learning_objectives',
  'event_type',
  'course_event_info',
  'sponsor_by_image',
  'course_banner_video',
  'course_banner_image',
  'course_gallery',
  'terms',
  'refund_policy',
  'company_name',
  'contact_email',
  'contact_phone',
  'contact_website',
  'status',
  'active_status',
  'register_link',
  'rsvp_date',
  'webinar_link',
  'youtube_link',
  'facebook_link',
  'instagram_link',
  'linkedin_link',
  'community_user_type'

];
// ==========================  JOB FIELDS ==========================
const JOB_FIELDS = [
  'id',
  'title',
  'j_type',
  'j_role',
  'description',
  'TypeofEmployment',
  'availability_date',
  'auto_expiry_date',
  'years_of_experience',
  'dental_practice_id',
  'dental_supplier_id',
  'active_status',
  'location',
  'logo',
  'state',
  'city',
  'salary',
  'company_name',
  'website_url',
  'pay_range',
  'education',
  'video',
  'closed_at',
  'status',
  'offered_benefits',
  'country',
  'endDateToggle',
  'pay_max',
  'pay_min',
  'hiring_period',
  'no_of_people',
  'rate_billing',
  'linkedin_url',
  'instagram_url',
  'facebook_url',
  'clinic_logo',
  'timings',
  'banner_image',
  'timingtoggle',
  'created_at',
  'job_applicants_aggregate { aggregate { count } }',
  'start_Date'
];
// ==========================  BANNER FIELDS ==========================
const BANNER_FIELDS = [
  'id',
  'url',
  'image',
  'status',
  'from_id',
  'created_at',
  'updated_at',
  'banner_name',
  'expiry_date',
  'schedule_date',
  'category_name',
];
// ==========================  BANNER CATEGORY FIELDS ==========================
const BANNER_CATEGORY_FIELDS = [
  'id',
  'name',
  'dimensions',
  'banner_location',
  'timer',
  'status',
];
// ==========================  DIRECTORY FIELDS ==========================
const DIRECTORY_FIELDS = [
  'id',
  'company_name',
  'phone',
  'email',
  'website',
  'type',
  'logo',
  'profession_type',
  'directory_category_id',
  'community_id'
];
// ==========================  REGISTERED USER CLAIM FIELDS ==========================
const REGISTERED_USER_CLAIM_FIELDS = [];
// ==========================  COURSE REGISTERED USERS ==========================
const COURSE_REGISTERED_USER_FIELDS = [
  'id',
  'created_at',
  'updated_at',
  'course_name',
  'type',
  'presented_by_image',
  'presented_by_name',
  'status',
  'active_status',
  'afterwards_price',
  'presenters',
  'created_by_id'
];
// ==========================  COURSE TYPE FIELDS ==========================
const COURSE_TYPE_FIELDS = [
  'created_at',
  'id',
  'name',
  'updated_at',
];
const NEWSFEED_CATEGORY = [
  'id',
  'category_name',
  'created_at',
  'updated_at',
  'created_by',
  'community_id',
  'created_by_user_id',
];
// ==========================  MASTER EXPORT ==========================
export const TABLE_FIELDS : { [key in keyof typeof Tables]?: string[] } = {
  Banner_Categories: BANNER_CATEGORY_FIELDS,
  Registered_User_Claim: REGISTERED_USER_CLAIM_FIELDS,
  Directories: DIRECTORY_FIELDS,
  Courses: COURSE_FIELDS,
  Banners: BANNER_FIELDS,
  Jobs: JOB_FIELDS,
  Course_Registered_Users: COURSE_REGISTERED_USER_FIELDS,
  Course_type: COURSE_TYPE_FIELDS,
  NewsfeedCategories: NEWSFEED_CATEGORY,
};

